module.exports = __webpack_public_path__ + "img/behind the firepower_.c3d21b5d.png";